import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'


export default {
    async create(model) {
        return await axios.post(`customer`, model)
    },
    async createCustomerModel(model){
        return await axios.post(`customer/create-customer`, model)
    },
    async upload(model) {
        return await axios.post(`customer/customer_upload`, model)
    },
    async fetchById(id) {
        console.log("ifff",id)
        return await axios.get(`customer/${id}`)
    },
    async fetch(query, page,filters) {
        return await axios.get(`customer?q=${query}&page=${page}&${buildQuery(filters)}`)
    },
    async update(id, model) {
        return await axios.put(`customer/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`customer/${id}`)
    },
    //////////////Customer Users////////////////////
    async createUser(customer_id, data) {
        return await axios.post(`customer/${customer_id}/users`, data)
    },
    async createContact(data) {
        console.log("datasss",data)
        return await axios.post(`customer-onboard`, data)
    },
    
    async fetchUser(customer_id, user_id) {
        return await axios.get(`customer/${customer_id}/users/${user_id}`)
    },
    async fetchUsers(customer_id) {
        return await axios.get(`customer/${customer_id}/users`)
    },
    async updateUser(customer_id, user_id, data) {
        return await axios.put(`customer/${customer_id}/users/${user_id}`, data)
    },
    async deleteUser(customer_id, user_id) {
        return await axios.delete(`customer/${customer_id}/users/${user_id}`)
    },

    async fetchAllCrmOpportunityStatus(query, page,filters) {
        return await axios.get(`crm-opportunity-status?q=${query}&page=${page}&${buildQuery(filters)}`)
    },
    async fetchAllCrmOpportunityStatusExcel(query, filters,exportExcel){
        return await axios.get(`crm-opportunity-status?q=${query}&export_csv=${exportExcel}&` + buildQuery(filters),{
            responseType: 'blob'
        })
    },
    async fetchAllCrmOpportunityStatusDashboard(query, filters,exportExcel){
        return await axios.get(`crm-opportunity-status?q=${query}&export_csv_dashboard=${exportExcel}&` + buildQuery(filters),{
            responseType: 'blob'
        })
    },
    async exportExcel(query_c, filters_c){
        return await axios.get(`customer/export-excel?q=${query_c}&` + buildQuery(filters_c),{
            responseType: 'blob'
        })
    },
}
